export default typeof jest !== 'undefined';
